document.addEventListener('DOMContentLoaded', function() {
  // Check if an element with the class "product-tabs-list" exists
  const productTabsList = document.querySelector('.product-tabs-list');
  if (productTabsList) {
  // Find the first "details" element inside the product-tabs-list
  const firstAccordion = productTabsList.querySelector('details:first-of-type');
  if (firstAccordion) {
      // Trigger a click event on the summary element of the first accordion
      const summary = firstAccordion.querySelector('summary');
      if (summary) {
        summary.click();
      }
    }
  }
  
  const productItemsModal = document.querySelectorAll('.product-info__block-item');
  if(productItemsModal){
    
      productItemsModal.forEach((item) => {
      const xModalElements = item.querySelectorAll('x-modal');
      
      // Append x-modal elements to the container
      xModalElements.forEach((modal) => {
        document.body.appendChild(modal);
      });
      
    });
  }  

});

// jQuery(document).ready(function ($) {
//   $('a[href="#modalFormWholesale"]').click(function(e){
//     e.preventDefault();
//     $('body').addClass('modal__opened');
//     $('.modal__contact--wholesale-form').removeClass('close');
//     $('.modal__contact--wholesale-form').addClass('active').show();
//     $('.main__wholesale-form .Alert--success--inner').hide();
//     $('.main__wholesale-form  .Form__Submit').show();
//   });
//   $('.modal__close--wholesale-form').click(function(){
//     $('.modal__contact--wholesale-form').addClass('close');
//     setTimeout(function() {
//        $('.modal__contact--wholesale-form').removeClass('active').hide();
//     }, 800);
    
//     $('body').removeClass('modal__opened');
//     history.replaceState({}, document.title, window.location.pathname);
//   });
//   $('.modal__contact--wholesale-form').mouseup(function(e) {
//     var container = $('.Container__wholesale-form');
//     if (!container.is(e.target) && container.has(e.target).length === 0) {
//       $('.modal__contact--wholesale-form').addClass('close');
//       setTimeout(function() {
//        $('.modal__contact--wholesale-form').removeClass('active').hide();
//       }, 800);
//       $('body').removeClass('modal__opened');
//       history.replaceState({}, document.title, window.location.pathname);
//     }
//   })
//   $(document).mouseup(function(e) {
//     var elDropdown = $('.custom-dropdown');
//     if (!elDropdown.is(e.target) && elDropdown.has(e.target).length === 0) {
//       elDropdown.find('.options').hide();
//     }
    
//   });
//   // $('.main__wholesale-form .Form__Submit').click(function(e){
//   //   e.preventdefault();
//   //   var form = $(this).parents('form');
//   //   var formData = form.serialize();

//   //   $.ajax({
//   //     type: form.attr('method'),
//   //     url: form.attr('action'),
//   //     data: formData,
//   //     success: function(response) {
//   //       form.trigger('reset');
//   //       form.find('.Alert--success--inner').show(1800).hide(300);
//   //       form.find('.Form__Submit').hide(1800).show(300);
//   //     },
//   //     error: function(xhr) {
        
//   //     }
//   //   });
//   // });
//   // Get the URL parameters
//   const urlParams = new URLSearchParams(window.location.search);
  
//   // Check if the 'contact_posted' parameter is set to 'true'
//   if (urlParams.get('contact_posted') === 'true') {
//     $('body').addClass('modal__opened');
//      $('.modal__contact--wholesale-form').addClass('active');
//      $('.main__wholesale-form .Alert--success--inner').show();
//      $('.main__wholesale-form  .Form__Submit').hide();
//      var targetOffset = $('.main__wholesale-form .Alert--success--inner').offset().top;
  
//      // Animate scrolling to the target div
//      $('.Container__wholesale-form').animate({
//        scrollTop: targetOffset
//      }, 1000);
//   } 

//   $('.selected-option').click(function() {
//     $(this).parents('.Form__Item').find('.options').toggle();
//   });

//   $('.custom-dropdown li').click(function() {
//     var selectedText = $(this).text();
//     var selectedValue = $(this).data('value');
//     $(this).parents('.Form__Item').find('.selected-option').text(selectedText);
//     $(this).parents('.Form__Item').find('.options').hide();
    
//     // Set the value of the select2 element
//      $(this).parents('.Form__Item').find('.selected2').val(selectedValue);
//   });

// });


jQuery(document).ready(function ($) {
  $('.open__popup--action').click(function(e){
    var idForrm = $(this).attr('href').slice(1);
    var formCurrent = $('[data-form-id="'+idForrm+'"]');
    if(formCurrent){
      e.preventDefault();
      e.stopPropagation()
      localStorage.setItem("idForrm",  idForrm);
      $('body').addClass('modal__opened');
      formCurrent.removeClass('close');
      formCurrent.addClass('active').show();
      formCurrent.find('.Alert--success--inner').hide();
      formCurrent.find('.Form__Submit').show();
    }
    
  });

  $('.main__wholesale-form .Form__Submit').click(function(){
    var idForm = $(this).parents('.modal__contact--wholesale-form').attr('data-form-id');
    if (idForm){
      localStorage.setItem("idForrm",  idForm);
    }
  });

  $('.modal__close--wholesale-form').click(function(){
    $('.modal__contact--wholesale-form').addClass('close');
    setTimeout(function() {
       $('.modal__contact--wholesale-form').removeClass('active').hide();
    }, 800);
    
    $('body').removeClass('modal__opened');
    localStorage.setItem("idForrm","")
    history.replaceState({}, document.title, window.location.pathname);
  });
  $('.modal__contact--wholesale-form').mouseup(function(e) {
    var container = $('.Container__wholesale-form');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.modal__contact--wholesale-form').addClass('close');
      setTimeout(function() {
       $('.modal__contact--wholesale-form').removeClass('active').hide();
      }, 800);
      $('body').removeClass('modal__opened');
      localStorage.setItem("idForrm","")
      history.replaceState({}, document.title, window.location.pathname);
    }
  })
  $(document).mouseup(function(e) {
    var elDropdown = $('.custom-dropdown');
    if (!elDropdown.is(e.target) && elDropdown.has(e.target).length === 0) {
      elDropdown.find('.options').hide();
    }
    
  });
  // $('.main__wholesale-form .Form__Submit').click(function(e){
  //   e.preventdefault();
  //   var form = $(this).parents('form');
  //   var formData = form.serialize();

  //   $.ajax({
  //     type: form.attr('method'),
  //     url: form.attr('action'),
  //     data: formData,
  //     success: function(response) {
  //       form.trigger('reset');
  //       form.find('.Alert--success--inner').show(1800).hide(300);
  //       form.find('.Form__Submit').hide(1800).show(300);
  //     },
  //     error: function(xhr) {
        
  //     }
  //   });
  // });
  // Get the URL parameters
  const urlParams = new URLSearchParams(window.location.search);
  

  // Check if the 'contact_posted' parameter is set to 'true'
  if (urlParams.get('contact_posted') === 'true') {
    var idForm = localStorage.getItem("idForrm");
    console.log("id: " + idForm);
    if(idForm){
      var formCurrent = $('[data-form-id="'+idForm+'"]');
      $('body').addClass('modal__opened');
      formCurrent.addClass('active');
      formCurrent.show();
      formCurrent.find('.Alert--success--inner').show();
      formCurrent.find('.Form__Submit').hide();
      var targetOffset = formCurrent.find('.Alert--success--inner').offset().top;
    
      // Animate scrolling to the target div
      $('.Container__wholesale-form').animate({
        scrollTop: targetOffset
      }, 1000);
    }    
    $('.page_transition_box').hide();
  } 

  $('.selected-option').click(function() {
    $(this).parents('.Form__Item').find('.options').toggle();
  });

  $('.custom-dropdown li').click(function() {
    var selectedText = $(this).text();
    var selectedValue = $(this).data('value');
    $(this).parents('.Form__Item').find('.selected-option').text(selectedText);
    $(this).parents('.Form__Item').find('.options').hide();
    
    // Set the value of the select2 element
     $(this).parents('.Form__Item').find('.selected2').val(selectedValue);
  });

});
